export default __webpack_public_path__ + "static/media/icon_arrow_down.d61db4c3.svg";